import React from "react";
import { Helmet } from 'react-helmet';
import ReadMoreAndLess from 'react-read-more-less';

const Landing = () => {
    return (
        <section>
            <Helmet>
                <title>Aarohi Hospital: About us</title>
            </Helmet>

            <div className="about-section about-section-background bg-white py-4 mt-5">
                <div className="container pt-5">
                    <div className="row align-items-center">
                        <div className="col-lg-6 pb-30">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="c-red font-weight-bolder">Aarohi Hospital, Born from trust. Built for care.</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-off-white pt-4 pb-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="c-blue font-weight-bolder">Heart of Our Care</h1>
                                </div>

                                

                                <div className="about-content">
                                    <p className="font-weight-bold">At Aarohi Hospital, our values guide every decision we make, every interaction we have, and every life we touch. They reflect our commitment to ethical medical practice, continuous learning, and compassionate care, supported by responsible use of modern technology.</p>

                                </div>
                                <div className="about-content">
                                <div className="row">
                        <div className="col-md-6 py-2">
                            <div className="card h-100 text-white">
                                <div className="card-body bg-blue">
                                    <h3 className="text-white">Patient-Centred Care</h3>
                                    <p className="text-white mb-0">
                                       The well-being of our patients is at the heart of everything we do. We are committed to delivering care that is safe, effective, respectful, and tailored to individual needs, ensuring comfort and satisfaction at every step.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 py-2">
                            <div className="card h-100">
                                <div className="card-body bg-red">
                                    <h3 className="text-white">Compassion & Community Trust</h3>
                                    <p className="text-white mb-0">
                                        We believe healthcare is built on trust. We treat every patient and family with empathy, dignity, and honesty, fostering long-lasting relationships within the communities we serve.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 py-2">
                            <div className="card h-100">
                                <div className="card-body bg-red">
                                    <h3 className="text-white">Collaboration & Teamwork</h3>
                                    <p className="text-white mb-0">
                                       Quality healthcare is a collective effort. Our multidisciplinary teams work together seamlessly, combining expertise across specialties to deliver coordinated and comprehensive care.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 py-2">
                            <div className="card h-100">
                                <div className="card-body bg-blue">
                                    <h3 className="text-white">Clinical Excellence & Innovation</h3>
                                    <p className="text-white mb-0">
                                        We continuously strive to improve clinical outcomes by embracing innovation, evidence-based practices, and advancing medical technology, while ensuring patient safety and ethical responsibility.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 py-2">
                            <div className="card h-100">
                                <div className="card-body bg-blue">
                                    <h3 className="text-white">Adaptability & Growth</h3>
                                    <p className="text-white mb-0">
                                        Healthcare is constantly evolving. We welcome change and improvement as opportunities to grow, adapt, and serve our patients better in a rapidly advancing medical landscape.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 py-2">
                            <div className="card h-100">
                                <div className="card-body bg-red">
                                    <h3 className="text-white">Efficiency & Responsibility</h3>
                                    <p className="text-white mb-0">
                                       We believe in delivering high-quality care in a cost-effective and responsible manner, ensuring optimal use of resources without compromising patient outcomes.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 py-2">
                            <div className="card h-100">
                                <div className="card-body bg-red">
                                    <h3 className="text-white">Respect for Individuals</h3>
                                    <p className="text-white mb-0">
                                        We respect every individual — patients, families, staff, and partners. We value diversity, protect patient rights, and promote a culture of mutual respect and fairness.
                                    </p>
                                </div>
                            </div>
                        </div>
                                 </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-white pt-4 pb-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="c-blue font-weight-bolder">Why Trust Us</h1>
                                </div>

                                <div className="about-content">
                                    <p className="text-black font-weight-normal">Aarohi Hospital is earning a reputation for compassionate care, clinical excellence, and a warm, family-oriented environment, where patients feel supported and respected at every stage of their treatment journey. We combine this culture of care with advanced medical technology and modern facilities, enabling us to deliver high-quality healthcare across multiple specialties.</p>

                                    <p className="text-black font-weight-normal">Our hospital attracts highly qualified consultants and specialists who are leaders in their respective fields. All our clinicians are board-certified, possess strong academic and clinical credentials, and bring extensive experience to their practice. Several of our consultant doctors are nationally and internationally recognised for their expertise and contributions to medicine.</p>

                                    <p className="text-black font-weight-normal">Clinical care at Aarohi Hospital is delivered within a structured clinical governance framework, ensuring patient safety, ethical practice, and consistent quality standards. Our nursing team forms the backbone of patient care — all nurses are fully qualified, professionally trained, and registered with the appropriate Nursing Council, providing round-the-clock care with dedication and empathy.</p>
                                 <p className="text-black font-weight-normal">We are committed to offering our patients advanced medical and surgical treatments, supported by the latest diagnostic and therapeutic technologies. From preventive care and routine procedures to complex surgeries and critical care, our focus remains on delivering safe, effective, and evidence-based treatment.</p>
                                <p className="text-black font-weight-normal">Aarohi Hospital also believes that quality healthcare should be accessible and affordable. We provide transparent, cost-effective care and offer clear estimates for consultations, investigations, and treatments for self-paying patients. We extend our services to both insured and self-pay patients, with support for insurance-covered treatments as per empanelment guidelines.</p>
                                <p className="text-black font-weight-normal">Our multidisciplinary team of doctors, nurses, and support staff work round the clock to closely monitor patient progress and ensure continuity of care. By consistently striving to achieve outcomes that meet and exceed accepted medical standards, Aarohi Hospital remains committed to being a trusted healthcare partner for our community.</p>
                               
                                
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <div className="about-section bg-off-white pt-4 pb-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="c-blue font-weight-bolder">Our Story</h1>
                                </div>

                                <div className="about-content">
                                    <p className="text-black font-weight-normal">Aarohi Hospital is the result of a journey rooted in friendship, shared purpose, and the trust of our community.</p>

                                    <p className="text-black font-weight-normal">In 2020, a group of young doctors came together with a simple vision — to provide ethical, accessible, and compassionate healthcare. This led to the establishment of Drithi Daycare & Polyclinic, which soon became a trusted healthcare destination for neighbourhood families. Encouraged by the faith and confidence of our patients, we expanded Drithi Daycare & Polyclinic to multiple peripheral areas of Bengaluru, continuing our commitment to quality care close to home.</p>

                                    <p className="text-black font-weight-normal">Over the years, the growing trust of our patients inspired us to take the next step. With a deep sense of responsibility towards the community that has stood by us, we envisioned Aarohi Hospital — a multi-specialty hospital designed to deliver comprehensive care under one roof, without compromising on ethics, affordability, or empathy.</p>
                                 <p className="text-black font-weight-normal">We are a young, doctor-led team driven by a passion for continuous learning, clinical excellence, and meaningful impact. At Aarohi Hospital, we believe that success is not measured only by advanced procedures or infrastructure, but by healthy families, informed patients, and a stronger community.</p>
                                <p className="text-black font-weight-normal">Our mission is to give back to the community that has trusted us with their health for so long — by providing dependable medical care, embracing modern technology responsibly, and treating every patient with dignity and compassion.</p>
                                <p className="text-black font-weight-normal">As we continue to grow, our purpose remains clear:
to serve with care, integrity, and empathy, and to build a healthier future together.</p>
                               
                                
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            

           
        </section>
    );
};

export default Landing;
